import {sendSvg as Icon__small__sendSvg} from '../Icon__small/Icon__small--send.js'

export var send = {
  name: 'send',
  category: 'icon',
  colorable: true,
  svg: Icon__small__sendSvg,
};
